const uiActions = {
    types: {
        UI_SET_PROPERTIES: 'UI_SET_PROPERTIES',
        SET_STIMULUS_STATE: 'SET_STIMULUS_STATE',
    },

    setProperties(properties) {
        return { type: this.types.UI_SET_PROPERTIES, properties };
    },

    uiWindowResized(viewSize) {
        return this.setProperties({ viewSize });
    },

    uiWindowOrientation(orientation) {
        return this.setProperties({ orientation });
    },

    uiSetMarketplaceTheme(marketplaceTheme) {
        return this.setProperties({ marketplaceTheme });
    },

    uiSetZoomFactor(zoomFactor) {
        return this.setProperties({ zoomFactor });
    },

    uiSetContrastOption(contrastOption) {
        return this.setProperties({ contrastOption });
    },

    uiSetA11yContrastOptions(a11yContrastOptions) {
        return this.setProperties({ a11yContrastOptions });
    },

    uiSetThemeVariables(variables) {
        return this.setProperties({ variables });
    },

    uiHideTimeRemaining(timeRemainingHidden) {
        return this.setProperties({ timeRemainingHidden });
    },

    uiSetDirection(direction) {
        return this.setProperties({ direction });
    },

    setBackgroundAudioStarted(backgroundAudioStarted) {
        return this.setProperties({ backgroundAudioStarted });
    },

    setBackgroundAudioCanceled(backgroundAudioCanceled) {
        return this.setProperties({ backgroundAudioCanceled });
    },

    setUseBackgroundAudioOverlay(value) {
        return this.setProperties({ useBackgroundAudioOverlay: value });
    },

    setBackgroundAudioStatus(value) {
        return this.setProperties({ backgroundAudioStatus: value });
    },

    setStimulusState(state) {
        return { type: this.types.SET_STIMULUS_STATE, state };
    },

    setAnsweredQuestionAutocommit(shouldAutocommitAnsweredQuestions) {
        return this.setProperties({ shouldAutocommitAnsweredQuestions });
    },

    setOwnPreviewMode(isOwnPreviewEnabled) {
        return this.setProperties({ isOwnPreviewEnabled });
    },

    setScreenWasExtended(screenWasExtended) {
        return this.setProperties({ screenWasExtended });
    },

    setIsTalviewInitAllocatedTimePassedErrorMessageDisplayed(isTalviewInitAllocatedTimePassedMessageDisplayed) {
        return this.setProperties({ isTalviewInitAllocatedTimePassedMessageDisplayed });
    },

    uiSetCurrentIframeTitle(currentIframeTitle) {
        return this.setProperties({ currentIframeTitle });
    },
};

export default uiActions;
